import React, { Fragment } from "react";
import { Text } from "../../assets/ui";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  StyledImageWrapper,
  StyledIndicator,
  StyledIndicatorWrapper,
  StyledSliderWrapper,
  StyledTextWrapper
} from "./ui";

class StepSlider extends React.Component {
  state = {
    nav1: null,
    nav2: null,
    currentSlide: 0,
    autoplay: true
  };

  componentDidMount() {
    this.setState({
      nav1: this.slider1,
      nav2: this.slider2
    });
  }

  stopAutoplay = () => {
      this.setState({ autoplay: false });
    };



  render() {
    const { data, color } = this.props;

    const settings1 = {
      dots: true,
      focusOnSelect: false,
      arrows: false,
      autoplay: this.state.autoplay,
      autoplaySpeed: 3000,
      speed: 500,
      slidesToShow: 1,
      infinite: true,
      adaptiveHeight: false,
      onSwipe: this.stopAutoplay,

      appendDots: dots => {
        return (
          <StyledIndicatorWrapper
            indicatorColor={color}
            onClick={this.stopAutoplay}
          >
            {dots}
          </StyledIndicatorWrapper>
        );
      },
      customPaging: i => {
        return (
          <div>
            <StyledIndicator></StyledIndicator>
          </div>
        );
      },

      responsive: [
        {
          breakpoint: 639,
          settings: {
            slidesPerRow: 1,
            slidesToShow: 1
          }
        },
        {
          breakpoint: 5000,
          settings: {
            vertical: true,
            slidesPerRow: 1,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };
    const settings2 = {
      dots: false,
      focusOnSelect: false,
      arrows: false,
      speed: 500,
      slidesToShow: 1,
      infinite: true,
      adaptiveHeight: true,
      onSwipe: this.stopAutoplay,
      responsive: [
        {
          breakpoint: 639,
          settings: {
            slidesPerRow: 1,
            slidesToShow: 1
          }
        },
      ]
    };

    return (
      <Fragment>
        <StyledSliderWrapper>
          <div>
            <StyledImageWrapper margin={["", null, null, "0 140px 0 0"]}>
              <div className="img-wrapper">
                <div className="phone-content">
                    <div className='phone-header'>

                    </div>
                  <Slider
                    asNavFor={this.state.nav2}
                    ref={slider => (this.slider1 = slider)}
                    {...settings2}
                  >
                    {data.map((el, index) => {
                      return (
                        <img src={`./images/${el.image}`} alt="" key={index} />
                      );
                    })}
                  </Slider>
                </div>
              </div>
            </StyledImageWrapper>
          </div>
          <div>
            <Slider
              asNavFor={this.state.nav1}
              ref={slider => (this.slider2 = slider)}
              {...settings1}
            >
              {data.map((el, index) => {
                return (
                  <StyledTextWrapper key={index} indicatorColor={color}>
                    <Text
                      fontSize={["21px", null, null, null]}
                      marginBottom={["16px"]}
                      fontWeight="bold"
                      color={color === "greenWhite" ? "#233247" : "#EBF3FF;"}
                    >
                      {el.title}
                    </Text>
                    <Text>{el.description}</Text>
                  </StyledTextWrapper>
                );
              })}
            </Slider>
          </div>
        </StyledSliderWrapper>
      </Fragment>
    );
  }
}

export default StepSlider;
